import React, { useContext, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getImage } from '../Utils/image_helper';
import Pride from 'react-canvas-confetti/dist/presets/fireworks';
import ReactGA from '../Utils/analytics';
import axios from 'axios';
import { logEvent } from '../helper/shakebug';
import { ConfigContext } from '../context/GlobalContext';

const randomInRange = (min, max) => {
  return Math.random() * (max - min) + min;
};

export const SuccessPage = () => {
  const { state } = useContext(ConfigContext);
  useEffect(() => {
    ReactGA.event("page_view", {
      page: "success",
    });
    logEvent("payment_success", state?.USERID);

  }, []);

  const decorateOptions = (defaultOptions) => ({
    ...defaultOptions,
    colors: ["#FF69B4", "#00FF00", "#FFA500"],
    scalar: randomInRange(0.5, 1.5),
    particleCount: Math.floor(randomInRange(5, 20)),
  });

  return (
    <>
      <Pride autorun={{ speed: 5 }} decorateOptions={decorateOptions} />

      <div className="success_popups">
        <div style={{ width: "100%" }}>
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <img src={getImage("success")} alt="Success" height={100} width={100} />
          </div>

          <h5 style={{ textAlign: "center", color: "#404040", fontSize: "10px", marginBottom: "10px" }}>
            Your Payment is Successful
          </h5>

          <p style={{ textAlign: "center", color: "#787878", fontSize: "15px" }}>
            Thank you for your payment. An automated payment receipt will be sent to your registered email.
          </p>

          <div className="backtohome" style={{ marginTop: "30px" }}>
            <Link to="/dashboard">
              <button className="text-primary">Back to Dashboard</button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};
